<template>
    <div class="container">
        <div class="banner">
            <div class="main">
                <div class="wow fadeInUp" ata-wow-delay="0.2s">
                    <div class="ban_title">貔貅管家</div>
                    <div class="ban_title">玉石珠宝行业的<span style="color: #3C6AFD">管理解决方案</span></div>
                    <div class="ban_content">
                        在玉石珠宝行业，貔貅管家是您的智慧助手，我们的全面集成和智能化ERP解决 方案旨在提升您企业的效率、降低成本，助您更轻松地应对复杂的业务挑战。
                    </div>
                    <div class="ban_btn btn" @click="handleToLogin">
                        立即体验
                    </div>
                </div>
            </div>
        </div>
        <!-- 系统特色 -->
        <div class="feature">
            <img src="../../assets/image/xtts_bg.png" class="bg_img">
            <div class="feature_content">
                <div class="title wow fadeInUp" ata-wow-delay="0.2s">系统特色</div>
                <div class="feature_content_main">
                    <div class="main_l wow fadeInLeft" ata-wow-delay="0.2s">
                        <img src="../../assets/image/xtts.png" alt="">
                    </div>
                    <div class="main_r">
                        <div class="main_r_item wow fadeInRight" ata-wow-delay="0.2s">
                            <img src="../../assets/image/znbb.png" alt="">
                            <div class="item">
                                <div class="item_t">智能报表</div>
                                <div class="item_b">数据分析，助力企业快速响应市场变化</div>
                            </div>
                        </div>
                        <div class="main_r_item wow fadeInRight" ata-wow-delay="0.2s">
                            <img src="../../assets/image/qmgl.png" alt="">
                            <div class="item">
                                <div class="item_t">全面管理</div>
                                <div class="item_b">从库存、采购到销售，一站式解决企业管理问题</div>
                            </div>
                        </div>
                        <div class="main_r_item wow fadeInRight" ata-wow-delay="0.2s">
                            <img src="../../assets/image/ssjk.png" alt="">
                            <div class="item">
                                <div class="item_t">实时监控</div>
                                <div class="item_b">即时掌握企业运营状态，提高决策效率</div>
                            </div>
                        </div>
                        <div class="main_r_item wow fadeInRight" ata-wow-delay="0.2s">
                            <img src="../../assets/image/dzh.png" alt="">
                            <div class="item">
                                <div class="item_t">定制化</div>
                                <div class="item_b">根据企业需求，灵活配置系统功能</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 全面解决行业面临的痛点 -->
        <div class="solve">
            <div class="solve_content">
                <div class="title wow fadeInUp" ata-wow-delay="0.2s">全面解决行业面临的痛点</div>
                <div class="solve_content_main">
                    <div class="main_l m1 wow fadeInLeft" ata-wow-delay="0.2s">
                        <div class="main_l_t">
                            <span class="t_1">01</span>
                            <span class="t_2">信息孤岛</span>
                        </div>
                        <div class="main_l_b">
                            传统的数据管理方式导致了各个部门之间存在信息孤岛， 系统通过集成各个业务模块，实现信息共享与流通，提 高企业整体协同效率。
                        </div>
                    </div>
                    <div class="main_l m2 wow fadeInLeft" ata-wow-delay="0.2s">
                        <div class="main_l_t">
                            <span class="t_1">02</span>
                            <span class="t_2">无法及时响应市场需求</span>
                        </div>
                        <div class="main_l_b">
                            企业在面对市场变化时，由于信息传递滞后或决策流程 繁琐，导致无法及时调整策略。系统提供实时的数据分 析和报告，帮助企业领导层迅速作出准确决策。
                        </div>
                    </div>
                    <div class="main_l m3 wow fadeInLeft" ata-wow-delay="0.2s">
                        <div class="main_l_t">
                            <span class="t_1">03</span>
                            <span class="t_2">人工成本高</span>
                        </div>
                        <div class="main_l_b">
                            大量繁重的手工操作不仅容易出错，而且增加了人工成本。 系统通过自动化流程，提高工作效率，降低了企业的人力 成本。
                        </div>
                    </div>
                    <img src="../../assets/image/rwtx.png" alt="" class="wow fadeInUp" ata-wow-delay="0.2s">
                    <div class="main_r m4 wow fadeInRight" ata-wow-delay="0.2s">
                        <div class="main_l_t">
                            <span class="t_1">04</span>
                            <span class="t_2">库存管理不足</span>
                        </div>
                        <div class="main_l_b">
                            不准确的库存数据和过时的库存管理方法可能导致库存 积压或短缺。系统提供实时的库存管理和监控，帮助企 业精确把握库存状况，减少库存成本。
                        </div>
                    </div>
                    <div class="main_r m5 wow fadeInRight" ata-wow-delay="0.2s">
                        <div class="main_l_t">
                            <span class="t_1">05</span>
                            <span class="t_2">财务管理不精准</span>
                        </div>
                        <div class="main_l_b">
                            企业财务管理繁杂，容易出现错误。系统能够提供准确的 财务报表、实时的财务数据，提高财务管理的精准度。
                        </div>
                    </div>
                    <div class="main_r m6 wow fadeInRight" ata-wow-delay="0.2s">
                        <div class="main_l_t">
                            <span class="t_1">06</span>
                            <span class="t_2">流程繁琐</span>
                        </div>
                        <div class="main_l_b">
                            企业内部存在大量手工操作，例如手动录入数据、人工 处理订单等，系统自动化这些流程，减轻员工工作负担， 降低错误率。
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 全方位的行业解决方案 -->
        <div class="programme">
            <img src="../../assets/image/jjfa_bg.png" class="bg_img" >
            <div class="programme_content">
                <div class="title wow fadeInUp" ata-wow-delay="0.2s">全方位的行业解决方案</div>
                <div class="programme_content_main">
                    <img src="../../assets/image/djzbpt.png" alt="" class="wow fadeInLeft" ata-wow-delay="0.2s">
                    <div class="p_content wow fadeInRight" ata-wow-delay="0.2s">
                        <div class="p_tit">对接直播平台</div>
                        <div class="p_nav">对接直我们将直播与业务管理完美融合，为您提供更智能、更高效的经营体验播平台</div>
                        <div class="p_b">
                            <div class="p_b_item">
                                <div class="p_b_item_t">销售订单实时同步</div>
                                <div class="p_b_item_b">系统与直播销售平台实现销售订单实时同步，确保您随时了解订单状况，避免漏单和重复工作。</div>
                            </div>
                            <div class="p_b_item">
                                <div class="p_b_item_t">多平台适配</div>
                                <div class="p_b_item_b">对接多平台适配，确保不同设备的观众都能顺利参与直播。无论是PC端、移动端还是其他平台， 都能享受到无缝的直播体验。</div>
                            </div>
                            <div class="p_b_item">
                                <div class="p_b_item_t">库存实时更新</div>
                                <div class="p_b_item_b">销售平台的订单变动将实时反映在系统中，确保库存信息的及时更新，避免因为不同平台信息 不同步而导致的问题。</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 货品管理 -->
        <div class="goods">
            <div class="goods_content">
                <div class="p_content wow fadeInLeft" ata-wow-delay="0.2s">
                    <div class="p_tit">货品管理</div>
                    <div class="p_nav">提高效率，降低成本，我们的货品管理系统助您一臂之力</div>
                    <div class="p_b">
                        <div class="p_b_item">
                            <div class="p_b_item_t">库存实时监控</div>
                            <div class="p_b_item_b">我们的货品管理系统让您随时随地了解库存状况，实现库存实时监控。无论是原材料、 半成品还是成品，一目了然，告别库存盲区。</div>
                        </div>
                        <div class="p_b_item">
                            <div class="p_b_item_t">采购管理</div>
                            <div class="p_b_item_b">灵活的采购流程，让您能够高效地安排供应商关系、管理订单，实现及时的货品补充， 降低缺货风险。</div>
                        </div>
                        <div class="p_b_item">
                            <div class="p_b_item_t">批次追溯</div>
                            <div class="p_b_item_b">追踪货品的生产批次，确保在需要时能够准确、快速地找到相关信息，提高产品质量 管理水平。</div>
                        </div>
                        <div class="p_b_item">
                            <div class="p_b_item_t">自定义报表</div>
                            <div class="p_b_item_b">根据您的需求，我们支持生成各类定制化报表，让您对货品管理的各个方面有清晰的 了解，助您做出更明智的决策。</div>
                        </div>
                        <div class="p_b_item">
                            <div class="p_b_item_t">无线扫描轻松搞定</div>
                            <div class="p_b_item_b">无论是入库、出库、盘点、销售、换货、退货、调拨，都支持通过无线扫描枪设备进 行精准扫描，既方便又快捷。</div>
                        </div>
                    </div>
                </div>
                <img src="../../assets/image/hpgl.png" class="wow fadeInRight" alt="" ata-wow-delay="0.2s">
            </div>
        </div>
        <!-- 财务管理 -->
        <div class="finance">
            <img src="../../assets/image/gwgl_bg.png" class="bg_img">
            <div class="finance_content">
                <div class="finance_content_main">
                    <img src="../../assets/image/cwgl.png" alt="" class="wow fadeInLeft" ata-wow-delay="0.2s">
                    <div class="p_content wow fadeInRight" ata-wow-delay="0.2s">
                        <div class="p_tit">财务管理</div>
                        <div class="p_nav">实时洞察，智能分析，助您精准掌握企业财务脉搏</div>
                        <div class="p_b">
                            <div class="p_b_item">
                                <div class="p_b_item_t">实时成交单据追踪</div>
                                <div class="p_b_item_b">我们的系统能够实时追踪每一笔成交单据，让您了解订单成交情况，把握业务进展。</div>
                            </div>
                            <div class="p_b_item">
                                <div class="p_b_item_t">销售明细透明呈现</div>
                                <div class="p_b_item_b">对销售明细进行透明、详尽的呈现，包括产品、客户、销售员等多维度信息，助您深度分析 销售状况。</div>
                            </div>
                            <div class="p_b_item">
                                <div class="p_b_item_t">多维度财务报表</div>
                                <div class="p_b_item_b">通过多维度财务报表功能，您可以根据不同的需求定制各类报表，如月度销售报表、季度利 润报表等。</div>
                            </div>
                            <div class="p_b_item">
                                <div class="p_b_item_t">报表生成</div>
                                <div class="p_b_item_b">根据成交单据和销售明细，系统能够生成符合要求的报表，提高财务合规性。</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 销售管理 -->
        <div class="goods">
            <div class="goods_content">
                <div class="p_content wow fadeInLeft" ata-wow-delay="0.2s">
                    <div class="p_tit">销售管理</div>
                    <div class="p_nav">智能销售，无缝协同，助您提升销售团队协作效能</div>
                    <div class="p_b">
                        <div class="p_b_item">
                            <div class="p_b_item_t">销售单据管理</div>
                            <div class="p_b_item_b">通过系统化的销售单据管理，实现订单全生命周期的追踪，从下单到发货，一目了然。</div>
                        </div>
                        <div class="p_b_item">
                            <div class="p_b_item_t">已销货品跟踪</div>
                            <div class="p_b_item_b">精准记录已销货品信息，包括销售数量、价格等，帮助您随时查看产品销售状况， 做出明智的库存决策。</div>
                        </div>
                        <div class="p_b_item">
                            <div class="p_b_item_t">客户关系管理</div>
                            <div class="p_b_item_b">构建客户档案，记录客户信息、购买历史，帮助您更好地了解客户需求，提高客户 满意度。</div>
                        </div>
                        <div class="p_b_item">
                            <div class="p_b_item_t">销售团队协作</div>
                            <div class="p_b_item_b">通过系统实现销售团队的协同工作，实时分享销售信息，提高团队合作效能。</div>
                        </div>
                        <div class="p_b_item">
                            <div class="p_b_item_t">数据统计与分析</div>
                            <div class="p_b_item_b">借助系统的数据统计与分析功能，您可以深入了解销售状况，优化销售策略，提升 企业盈利能力。</div>
                        </div>
                    </div>
                </div>
                <img src="../../assets/image/xsgl.png" alt="" class="wow fadeInRight" ata-wow-delay="0.2s">
            </div>
        </div>
        <!-- 一站式服务 -->
        <div class="service">
            <img src="../../assets/image/yzsfw_bg.png" class="bg_img">
            <div class="service_content">
                <div class="title wow fadeInUp" ata-wow-delay="0.2s">一站式服务</div>
                <div class="service_content_main wow fadeInUp" ata-wow-delay="0.2s">
                    <div class="s_t">在追求真正实现降本增效、业绩突破的道路上，我们携手您共同启程！貔貅管家致力于全面提升您的运营效率，助您在市场中更加强大竞争力。</div>
                    <div class="s_b">
                        <div class="s_b_item">
                            <img src="../../assets/image/jszc.png">
                            <div class="s_b_item_t">24/7技术支持</div>
                            <div class="s_b_item_b">全天候提供专业技术支持，确保系统稳定运行</div>
                        </div>
                        <div class="s_b_item">
                            <img src="../../assets/image/yhpx.png">
                            <div class="s_b_item_t">用户培训</div>
                            <div class="s_b_item_b">为您的团队提供系统培训，确保快速上手和高效使用</div>
                        </div>
                        <div class="s_b_item">
                            <img src="../../assets/image/dqgxysj.png">
                            <div class="s_b_item_t">定期更新与升级</div>
                            <div class="s_b_item_b">持续推出系统更新与升级，跟上行业最新技术 发展，提供更好的服务。</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 体验 -->
        <div class="experience">
            <div class="experience_content wow fadeInUp" ata-wow-delay="0.2s">
                <div class="experience_content_main">
                    开始您的ERP系统免费试用之旅。体验未来， 释放效能，为您的企业赋能！
                </div>
                <div class="experience_content_btn btn" @click="handleToLogin">
                    立即体验
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {

        }
    },
    mounted() {
        var wow = new this.$wow.WOW({
            boxClass: 'wow',
            animateClass: 'animated',
            offset: 0,
            mobile: true,
            live: true
        });
        wow.init();
    },
    methods: {
        handleToLogin() {
            window.location.href = "https://erp.gxlm.com";
        }
    }
}
</script>
<style scoped lang="scss">
$width: 1200px;
.container {
    width: 100vw;
    height: auto;
    background: #f8f8f8;
    .title {
        width: 100%;
        font-size: 30px;
        color: #333333;
        font-weight: bold;
        margin: 0 0 85px 0;
        padding-top: 85px;
        box-sizing: border-box;
        text-align: center;
        position: relative;
        &::after {
        content: '';
        width: 50px;
        height: 6px;
        background: #3C6AFD;
        position: absolute;
        left: 50%;
        bottom: -45px;
        transform: translateX(-50%);
        }
    }
    .banner {
        width: 100%;
        height: 550px;
        background: url('../../assets/image/px_banner.png');
        background-repeat: no-repeat;
            background-size: 100% auto;
        .main {
            width: $width;
            margin: 0 auto;
            padding-top: 156px;
            box-sizing: border-box;
            color: #222;
            .ban_title {
                font-size: 46px;
                font-weight: bold;
            }
            .ban_content {
                font-size: 16px;
                margin-top: 10px;
                color: #666666;
                width: 562px;
            }
            .ban_btn {
                width: 96px;
                height: 34px;
                border-radius: 4px 4px 4px 4px;
                background: #3C6AFD;
                color: #FFFFFF;
                text-align: center;
                line-height: 34px;
                margin-top: 27px;
                font-size: 16px;
                cursor: pointer;
                transition: all 0.3s ease;
            }
        }
    }
    .feature {
        width: 100%;
        height: 758px;
        background: #fff;
        position: relative;
        .bg_img {
            width: 435px;
            height: 437px;
            position: absolute;
            right: 0px;
            bottom: 0px;
            object-fit: cover;
        }
        &_content {
            width: $width;
            margin: 0 auto;
            position: relative;
            &_main {
                display: flex;
                .main_l{
                    img {
                        flex: 1;
                        width: 640px;
                        height: 520px;
                        object-fit: cover;
                    }
                }
                .main_r{
                    flex: 1;
                    padding-top: 60px;
                    padding-left: 130px;
                    box-sizing: border-box;
                    display: flex;
                    flex-direction: column;
                    row-gap: 46px;
                    &_item {
                        display: flex;
                        column-gap: 30px;
                        img {
                            width: 60px;
                            height: 60px;
                        }
                        .item {
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            &_t {
                                font-size: 20px;
                                margin-bottom: 4px;
                            }
                            &_b {
                                font-size: 14px;
                                color: #666666;
                            }
                        }
                    }
                }
            }
        }
    }
    .solve {
        width: 100%;
        height: 832px;
        background: url('../../assets/image/td_bg.png');
        background-repeat: no-repeat;
        background-size: 100% auto;
        &_content {
            width: $width;
            height: 100%;
            margin: 0 auto;
            display: flex;
            flex-direction: column;
            position: relative;
            &_main {
                flex: 1;
                display: flex;
                align-items: center;
                justify-content: center;
                position: relative;
                img {
                    width: 348px;
                    height: 326px;
                }
                .main_l,.main_r {
                    width: 440px;
                    height: 160px;
                    position: absolute;
                    background: url('../../assets/image/tx_1.png');
                    background-repeat: no-repeat;
                    background-size: 100% auto;
                    padding: 20px 50px 20px 30px;
                    box-sizing: border-box;
                    &_t {
                        font-weight: bold;
                        display: flex;
                        align-items: center;
                        column-gap: 20px;
                        .t_1 {
                            font-size: 32px;
                            color: #3C6AFD;
                        }
                        .t_2 {
                            font-size: 20px;
                            color: #333333;
                        }
                    }
                    &_b {
                        font-size: 14px;
                        color: #666666;
                        margin-top: 8px;
                    }
                }
                .main_r {
                    width: 440px;
                    height: 160px;
                    position: absolute;
                    background: url('../../assets/image/tx_2.png');
                    background-repeat: no-repeat;
                    background-size: 100% auto;
                    padding: 20px 30px 20px 50px;
                    box-sizing: border-box;
                }
                .m1 {
                    left: 50px;
                    top: 20px;
                }
                .m2 {
                    left: 0px;
                    top: 222px;
                }
                .m3 {
                    left: 50px;
                    top: 414px;
                }
                .m4 {
                    right: 50px;
                    top: 20px;
                }
                .m5 {
                    right: 0px;
                    top: 222px;
                }
                .m6 {
                    right: 50px;
                    top: 414px;
                }
            }
        }
    }
    .programme {
        width: 100%;
        height: 758px;
        background: #fff;
        position: relative;
        .bg_img {
            width: 435px;
            height: 437px;
            position: absolute;
            left: 0px;
            top: 0px;
            object-fit: cover;
        }
        &_content {
            width: $width;
            margin: 0 auto;
            position: relative;
            &_main {
                display: flex;
                img {
                    width: 560px;
                    height: 432px;
                    object-fit: cover;
                }
                .p_content {
                    padding-top: 50px;
                    padding-left: 30px;
                    box-sizing: border-box;
                    .p_tit { 
                        font-size: 28px;
                        font-weight: bold;
                        color: #3C6AFD;
                    }
                    .p_nav {
                        font-size: 14px;
                        color: #666666;
                        margin-top: 6px;
                    }
                    .p_b {
                        margin-top: 24px;
                        &_item {
                            padding-left: 20px;
                            box-sizing: border-box;
                            margin-bottom: 20px;
                            &_t {
                                font-size: 16px;
                                font-weight: bold;
                                margin-bottom: 10px;
                                position: relative;
                                &::before {
                                    content: '';
                                    width: 12px;
                                    height: 12px;
                                    background: rgba(60,106,253,0.2);
                                    border-radius: 50%;
                                    position: absolute;
                                    left: -20px;
                                    top: 5px;
                                }
                                &::after {
                                    content: '';
                                    width: 6px;
                                    height: 6px;
                                    background: #3C6AFD;
                                    border-radius: 50%;
                                    position: absolute;
                                    left: -17px;
                                    top: 8px;
                                }
                            }
                            &_b{
                                font-size: 14px;
                                color: #666666;
                            }
                        }
                    }
                }
            }
        }
    }
    .goods {
        width: 100%;
        height: 610px;
        background: url('../../assets/image/hpgl_bg.png');
        background-repeat: no-repeat;
        background-size: 100% auto;
        &_content {
            width: $width;
            height: 100%;
            margin: 0 auto;
            display: flex;
            align-items: center;
            .p_content {
                padding-top: 24px;
                padding-right: 83px;
                box-sizing: border-box;
                .p_tit { 
                    font-size: 28px;
                    font-weight: bold;
                    color: #3C6AFD;
                }
                .p_nav {
                    font-size: 14px;
                    color: #666666;
                    margin-top: 6px;
                }
                .p_b {
                    margin-top: 24px;
                    &_item {
                        padding-left: 20px;
                        box-sizing: border-box;
                        margin-bottom: 20px;
                        &_t {
                            font-size: 16px;
                            font-weight: bold;
                            margin-bottom: 10px;
                            position: relative;
                            &::before {
                                content: '';
                                width: 12px;
                                height: 12px;
                                background: rgba(60,106,253,0.2);
                                border-radius: 50%;
                                position: absolute;
                                left: -20px;
                                top: 5px;
                            }
                            &::after {
                                content: '';
                                width: 6px;
                                height: 6px;
                                background: #3C6AFD;
                                border-radius: 50%;
                                position: absolute;
                                left: -17px;
                                top: 8px;
                            }
                        }
                        &_b{
                            font-size: 14px;
                            color: #666666;
                        }
                    }
                }
            }
            img {
                width: 560px;
                height: 432px;
                object-fit: cover;
            }
        }
    }
    .finance {
        width: 100%;
        height: 593px;
        background: #fff;
        position: relative;
        .bg_img {
            width: 435px;
            height: 437px;
            position: absolute;
            right: 0px;
            top: 0px;
            object-fit: cover;
        }
        &_content {
            width: $width;
            height: 100%;
            margin: 0 auto;
            display: flex;
            align-items: center;
            position: relative;
            &_main {
                display: flex;
                img {
                    width: 560px;
                    height: 432px;
                    object-fit: cover;
                }
                .p_content {
                    padding-top: 16px;
                    padding-left: 30px;
                    box-sizing: border-box;
                    .p_tit { 
                        font-size: 28px;
                        font-weight: bold;
                        color: #3C6AFD;
                    }
                    .p_nav {
                        font-size: 14px;
                        color: #666666;
                        margin-top: 6px;
                    }
                    .p_b {
                        margin-top: 24px;
                        &_item {
                            padding-left: 20px;
                            box-sizing: border-box;
                            margin-bottom: 20px;
                            &_t {
                                font-size: 16px;
                                font-weight: bold;
                                margin-bottom: 10px;
                                position: relative;
                                &::before {
                                    content: '';
                                    width: 12px;
                                    height: 12px;
                                    background: rgba(60,106,253,0.2);
                                    border-radius: 50%;
                                    position: absolute;
                                    left: -20px;
                                    top: 5px;
                                }
                                &::after {
                                    content: '';
                                    width: 6px;
                                    height: 6px;
                                    background: #3C6AFD;
                                    border-radius: 50%;
                                    position: absolute;
                                    left: -17px;
                                    top: 8px;
                                }
                            }
                            &_b{
                                font-size: 14px;
                                color: #666666;
                            }
                        }
                    }
                }
            }
        }
    }
    .service {
        width: 100%;
        height: 472px;
        background: #fff;
        position: relative;
        .bg_img {
            width: 435px;
            height: 437px;
            position: absolute;
            left: 0px;
            top: 0px;
            object-fit: cover;
        }
        &_content {
            width: $width;
            margin: 0 auto;
            font-size: 14px;
            color: #666;
            text-align: center;
            .s_b {
                margin-top: 60px;
                display: grid;
                grid-template-columns: repeat(3, 1fr);
                img {
                    width: 36px;
                    height: 36px;
                }
                &_item {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    row-gap: 10px;
                    &_t {
                        font-size: 18px;
                        color: #333;
                    }
                    &_b {
                        width: 280px;
                    }
                }
            }
        }
    }
    .experience {
        width: 100%;
        height: 186px;
        background: #3C6AFD;
        &_content {
            width: $width;
            margin: 0 auto;
            padding: 30px 0;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-items: center;
            &_main {
                width: 558px;
                color: #fff;
                font-size: 28px;
                font-weight: bold;
                text-align: center;
            }
            &_btn {
                width: 100px;
                height: 32px;
                background: #FFFFFF;
                border-radius: 4px;
                border: 1px solid #3C6AFD;
                font-size: 16px;
                color: #3C6AFD;
                text-align: center;
                line-height: 32px;
                cursor: pointer;
                margin-top: 20px;
                transition: all 0.3s ease;
            }
        }
    }
}
</style>